import { Breadcrumb } from 'react-breadcrumbs';
import { Helmet } from 'react-helmet-async';
import { Link, Redirect, useHistory, useParams } from 'react-router-dom';

import CopyToClipboardButton from '../../../../library/inputs/CopyToClipboardButton';
import Flash from '../../../../library/utils/Flash';
import MultiStepFormStep from '../../../../library/inputs/MultiStepFormStep';
import Table from '../../../../library/data-display/Table';
import { Step, useNewAvailability } from './use-new-availability';
import { useApplication } from '../../../../../hooks/queries/applications';
import { correctPath } from 'libraries/gem';

const SendLinkStep = () => {
  const history = useHistory();

  const { id } = useParams<{ id: string }>();

  const application = useApplication(id).data!;

  const {
    availabilityId,
    completedStep,
  } = useNewAvailability();

  if (completedStep < Step.SendLink) {
    return <Redirect to={correctPath(`/app/candidates/${id}/request-availability/preferences`)} />;
  }

  const handleNext = async () => {
    history.push(correctPath(`/app/candidates/${id}/availabilities/${availabilityId}`));
  };

  return (
    <Breadcrumb
      data={{
        title: '4. Send Link',
        pathname: correctPath(`/app/candidates/${id}/request-availability/send`),
      }}
    >
      <MultiStepFormStep
        className="form-step-send"
        isFirstStep
        isLastStep
        nextButtonValue="Done"
        onNext={handleNext}
      >
        <Helmet>
          <title>4. Send Link | Request availability from {application.candidate.name || 'Unknown'} for {application.current_stage?.name} | Gem Scheduling</title>
        </Helmet>
        <Flash
          message="Availability link successfully created!"
          showFlash
          type="success"
        />
        <Table
          data={[{ link: correctPath(`/availability/${availabilityId}`) }]}
          layout="horizontal"
          schema={[{
            header: 'Link',
            displayValue: ({ link }) => (
              <div className="send-link">
                <Link
                  target="_blank"
                  to={link}
                >
                  {window.origin}{link}
                </Link>
                <CopyToClipboardButton textToCopy={`${window.origin}${link}`} />
              </div>
            ),
          }]}
        />
        <p>
          Now, you can send the candidate an email with their unique link.
        </p>
        <p>
          When you are finished sending your email, click Done to exit the workflow.
        </p>
      </MultiStepFormStep>
    </Breadcrumb>
  );
};

export default SendLinkStep;
